import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    refusedLabel: 'Refused',
    replaceDocCta: 'Replace my document',
  },
  fr: {
    refusedLabel: 'Refusé',
    replaceDocCta: 'Remplacer le document',
  },
} as const);
